// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"53":"webfontloader","594":"about"}[chunkId] + "." + {"53":"9da1cff5","594":"1a3c147f"}[chunkId] + ".js";
};